import QRCode from 'qrcode'
import { useEffect, useState } from 'react'

export interface QrCodeProps {
  /** The exact URL encoded — must be the same string the tappable link uses. */
  value: string
  size?: number
  alt: string
}

/**
 * `LGH-050`, `PLT-106`. Rendered console-side from `deepLink` — `1C`'s own
 * assumption in `REQ-platform-core-the-reverse-login-code-wire-shape-for-
 * console`, confirmed rather than left implicit (see `3L`'s answer on that
 * REQ). `qrcode`'s `toDataURL` runs against a `<canvas>` in the browser, the
 * same package `FQG-018` used server-side for the demo PDF's own QR — same
 * mechanism, different rendering context (a live page, not a rendered PDF),
 * per `LGH-050`'s own text.
 */
export function QrCode({ value, size = 176, alt }: QrCodeProps) {
  const [dataUri, setDataUri] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    QRCode.toDataURL(value, { width: size, margin: 1 })
      .then((uri) => {
        if (!cancelled) setDataUri(uri)
      })
      .catch(() => {
        if (!cancelled) setDataUri(null)
      })
    return () => {
      cancelled = true
    }
  }, [value, size])

  if (dataUri === null) {
    return <div style={{ width: size, height: size, background: 'var(--paper-2)' }} aria-hidden />
  }

  return <img src={dataUri} alt={alt} width={size} height={size} />
}
